import React from 'react';
import { string, func } from 'prop-types';
import { translate } from 'react-i18next';
import { compose } from 'redux';
import { connect } from 'react-redux';

import YoutubeVideo from '@blueberry/components/YoutubeVideo';
import Link from '@blueberry/components/Link';

import BannerContent from './components/BannerContent';

import { generatePostURL } from '@blueberry/redux/navigation';

import { VIDEO } from '@blueberry/constants/postType';

import styles from './Banner.scss';

const mapStateToProps = state => ({
  getPostURL: generatePostURL(state),
});

function Banner({
  title,
  introText,
  publishDate,
  type,
  id,
  mediaUrl,
  teaserId,
  teaserImageUrl,
  teaserEmbedUrl,
  authorName,
  urlTitle,
  getPostURL,
}) {
  const postURL = getPostURL({
    title: urlTitle,
    id,
  });
  // show empty in case not setting teaser
  const videoBanner = (
    <div className={styles.root}>
      <YoutubeVideo
        videoUrl={teaserEmbedUrl}
        videoId={teaserId}
        className={styles.media}
        autoplay
        withoutBlack
        playlist={teaserId}
      />
      <div className={styles.mobileMedia}>
        <Link to={postURL} className={styles.imageLink}>
          <img src={teaserImageUrl} />
        </Link>
      </div>
      <div className={styles.block}>
        <BannerContent
          url={postURL}
          title={title}
          describe={introText}
          publishDate={publishDate}
          authorName={authorName}
          isVideo
        />
      </div>
    </div>
  );

  const imageBanner = (
    <div className={styles.root}>
      <Link to={postURL} className={styles.imageLink}>
        <img src={mediaUrl} className={styles.mediaImage} />
      </Link>
      <div className={styles.block}>
        <BannerContent
          url={postURL}
          title={title}
          describe={introText}
          publishDate={publishDate}
          authorName={authorName}
        />
      </div>
    </div>
  );

  if (type === VIDEO) {
    return videoBanner;
  }

  return imageBanner;
}

Banner.propTypes = {
  authorName: string.isRequired,
  getPostURL: func.isRequired,
  id: string.isRequired,
  introText: string.isRequired,
  mediaUrl: string.isRequired,
  publishDate: string.isRequired,
  t: func.isRequired,
  title: string.isRequired,
  type: string.isRequired,
  urlTitle: string.isRequired,
  teaserEmbedUrl: string,
  teaserId: string,
  teaserImageUrl: string,
};

Banner.defaultProps = {
  teaserId: '',
  teaserImageUrl: '',
  teaserEmbedUrl: '',
};

export default compose(translate('banner'), connect(mapStateToProps))(Banner);



// WEBPACK FOOTER //
// ./app/components/Banner/Banner.jsx